import React, { Component } from 'react';
// Needed for onTouchTap
import './ConnexionLayout.css';
import { browserHistory } from 'react-router';
import LanguageMenu from '../../components/languageMenu/LanguageMenu';
import { connect } from 'react-redux'
import { setLanguage } from '../../store/language/LanguageActions'
// Enum
import PAGES from '../../enums/PageEnum';
import COOKIES from '../../enums/CookieEnum';
// Utils
import { getCookie, deleteCookie } from '../../utils/CookieUtils';

/*************************************************
 * ************* Mapping du store ****************
 *************************************************/

const mapDispatchToProps = (dispatch) => ({
    setLanguage: (language) => dispatch(setLanguage(language))
});

const mapStateToProps = (state) => ({
    languageStore: state.languageState,
});

/**
 * Ecran de connexion
 */
class ConnexionLayout extends Component {

    /*************************************************
     * **************** LifeCycle ********************
     *************************************************/
    constructor(props) {
        super(props);
        this.state = {
            languageStore: props.languageStore
        };
    }

    componentWillMount() {
        if(this.props.location.pathname && this.props.location.pathname.includes && this.props.location.pathname.includes('key')){
            deleteCookie(COOKIES.SID);
        }
        if (getCookie(COOKIES.SID)) {
            browserHistory.push(PAGES.HOME_PAGE);
        }
    }

    render() {
        const page = React.cloneElement(this.props.children, {
            language: this.props.language,
        });

        return(
            <div className="loginContainer">
                <div className="loginLeft">
                    <div className="logo"><div><img src={process.env.PUBLIC_URL + '/MP_long_logo.png'} alt="logo"/></div></div>
                    <div className="lang"><LanguageMenu selectedItem={this.state.languageStore.language} onChangeAction={(value) => {this.props.setLanguage(value)}} bottom={false}> </LanguageMenu></div>
                </div>
                <div className="loginZone">
                    {page}
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConnexionLayout);



// WEBPACK FOOTER //
// ./src/ui/connexion/ConnexionLayout.js